import VendorSelector from "components/_Pages/templates/pages/VendorSelector";

const VendorSelectorPage = () => <VendorSelector.Aurora />;

export default VendorSelectorPage;
